import Vue from "vue";
import Router from "vue-router";

import login from "@/page/login";
import main from "@/page/main";
import userManager from "@/page/basic/userManager";
import myMessage from "@/page/basic/myMessage";
import resetPassword from "@/page/basic/resetPassword";
import handleDiary from "@/page/superAdmin/handleDiary";
import roleManager from "@/page/basic/roleManager";
import permission from "@/page/basic/permission";

Vue.use(Router);

const permissionRoutes = [
  // main
  {
    path: "/main",
    component: main,
    redirect: "/main/permission",
    children: [
      //   basic
      // {
      //   path: "userManager",
      //   component: userManager
      // },
      // {
      //   path: "myMessage",
      //   component: myMessage
      // },
      // {
      //   path: "roleManager",
      //   component: roleManager
      // },
      {
        path: "resetPassword",
        component: resetPassword
      },
      {
        path: "permission",
        meta: { permiss: "page-main/permission" },
        component: permission
      },
      //notify
      {
        path: "/websiteManager",
        meta: { permiss: "page-websiteManager" },
        component: () => import("@/page/websiteManager/websiteManager.vue")
      },
      {
        path: "/websiteManagerEdit",
        meta: { permiss: "page-websiteManagerEdit" },
        component: () => import("@/page/websiteManager/websiteManagerEdit.vue")
      },
      {
        path: "/copywebsiteManager",
        meta: { permiss: "page-copywebsiteManager" },
        component: () => import("@/page/websiteManager/copywebsiteManager.vue")
      },
      //personal
      {
        path: "/personalManage",
        meta: { permiss: "page-personalManage" },
        component: () => import("@/page/personal/personalManage.vue")
      },
      {
        path: "/editPersonal",
        // meta: { permiss: "page-editPersonal" },
        component: () => import("@/page/personal/editPersonal.vue")
      }
    ]
  },
  //module
  {
    path: "/module",
    component: main,
    redirect: "/module/moduleManager",
    children: [
      {
        path: "moduleManager",
        meta: { permiss: "page-moduleManager/moduleManager" },
        component: () => import("@/page/moduleManager/moduleManager.vue")
      },
      {
        path: "moduleBottomManager",
        meta: { permiss: "page-moduleManager/moduleBottomManager" },
        component: () => import("@/page/moduleManager/moduleBottomManager.vue")
      },
      {
        path: "bannerManager",
        meta: { permiss: "page-moduleManager/bannerManager" },
        component: () => import("@/page/moduleManager/bannerManager.vue")
      },
      {
        path: "moduleDetailManager",
        meta: { permiss: "page-moduleManager/moduleDetailManager" },
        component: () => import("@/page/moduleManager/moduleDetailManager.vue")
      },
      {
        path: "moduleDetailSingleManager",
        meta: { permiss: "page-moduleManager/moduleDetailSingleManager" },
        component: () =>
          import("@/page/moduleManager/moduleDetailSingleManager.vue")
      },
      {
        path: "moduleDetailRichEdit",
        meta: { permiss: "page-moduleManager/moduleDetailRichEdit" },
        component: () => import("@/page/moduleManager/moduleDetailRichEdit.vue")
      },
      {
        path: "moduleDetailManyManager",
        meta: { permiss: "page-moduleManager/moduleDetailManyManager" },
        component: () =>
          import("@/page/moduleManager/moduleDetailManyManager.vue")
      },
      {
        path: "moduleDetailFileManager",
        meta: { permiss: "page-moduleManager/moduleDetailFileManager" },
        component: () =>
          import("@/page/moduleManager/moduleDetailFileManager.vue")
      },
      {
        path: "moduleDetailSegmentManager",
        meta: { permiss: "page-moduleManager/moduleDetailSegmentManager" },
        component: () =>
          import("@/page/moduleManager/moduleDetailSegmentManager.vue")
      },
      {
        path: "moduleDetailSegmentSpecialManager",
        meta: {
          permiss: "page-moduleManager/moduleDetailSegmentSpecialManager"
        },
        component: () =>
          import("@/page/moduleManager/moduleDetailSegmentSpecialManager.vue")
      },
      {
        path: "suggestionManager",
        meta: {
          permiss: "page-suggestionManager"
        },
        component: () => import("@/page/moduleManager/suggestionManager.vue")
      }
    ]
  },
  // statistics
  {
    path: "/statistics",
    component: main,
    redirect: "/statistics/detailLogEchart",
    children: [
      {
        path: "detailLogEchart",
        meta: {
          permiss: "page-detailLogEchart"
        },
        component: () => import("@/page/statistics/detailLogEchart.vue")
      },
      {
        path: "detailLogManager",
        meta: {
          permiss: "page-detailLogManager"
        },
        component: () => import("@/page/statistics/detailLogManager.vue")
      }
    ]
  },
  //superAdmin
  {
    path: "/super",
    component: main,
    redirect: "/super/companyManage",
    children: [
      {
        path: "companyManage",
        meta: { permiss: "page-super/companyManage" },
        component: () => import("@/page/superAdmin/companyManage.vue")
      },
      {
        path: "companyAdmin",
        meta: { permiss: "page-super/companyAdmin" },
        component: () => import("@/page/superAdmin/companyAdmin.vue")
      },
      {
        path: "handleDiary",
        meta: { permiss: "page-super/handleDiary" },
        component: handleDiary
      },
      {
        path: "resourceMange",
        meta: { permiss: "page-super/resourceMange" },
        component: () => import("@/page/superAdmin/resourceMange.vue")
      }
    ]
  },

  //basic
  {
    path: "/basic",
    component: main,
    redirect: "/basic/websiteMessage",
    children: [
      {
        path: "websiteMessage",
        meta: { permiss: "page-basic/websiteMessage" },
        component: () => import("@/page/basic/websiteMessage.vue")
      },
      {
        path: "myMessage",
        meta: { permiss: "page-basic/myMessage" },
        component: () => import("@/page/basic/myMessage.vue")
      },
      {
        path: "enumSetting",
        meta: { permiss: "page-basic/enumSetting" },
        component: () => import("@/page/basic/enumSetting.vue")
      }
    ]
  }
];

export default new Router({
  routes: [
    {
      path: "/",
      component: login
    },
    //window
    {
      component: main,
      path: "/window",
      children: [
        {
          path: "/",
          component: () => import("@/page/window/myWindow.vue")
        }
      ]
    },
    {
      path: "/showPage",
      component: () => import("@/page/moduleManager/showPage.vue")
    },

    {
      name: "404",
      path: "/404",
      component: () => import("@/page/404.vue")
    },
    ...permissionRoutes
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js